import React from "react";

import { Grid } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { FiDownload } from "react-icons/fi";

import { useAppState } from "../../../../../../context/StateContext";
import { CartonView } from "../../../../../../models/carton";
import { DefaultTooltip } from "../../../../Tooltip";
import useStyles from "../../../styles";
import { ConfirmReceiveSSCCHandles } from "../../ConfirmReceiveSSCC";

interface Props {
  carton?: CartonView;
  show?: boolean;

  confirmReceiveRef: React.RefObject<ConfirmReceiveSSCCHandles>;
}

const ReceiveButton = (props: Props) => {
  const { carton, show, confirmReceiveRef } = props;

  const { t: translate } = useTranslation();
  const { isFMVersion } = useAppState();
  const classes = useStyles();

  if (!isFMVersion || !show || !carton || !carton.sscc || carton.isReceivedByCfs) return null;

  const onClick = () => confirmReceiveRef.current?.open(false, carton.sscc);

  return (
    <Grid item data-cy="receive-sscc" className={classes.roundButton}>
      <DefaultTooltip title={translate("receiveSSCC")}>
        <div onClick={onClick}>
          <FiDownload
            size={GridConstants.defaultRowActionSize}
            color={GridConstants.defaultColorIcon}
          />
        </div>
      </DefaultTooltip>
    </Grid>
  );
};

export default ReceiveButton;
